import React from "react";

import Services from "../../../components/ServicesImgText";

import energy from "../../../images/services/ServicesPage/greenrenewable1.png";

const index = () => {
  return (
    <div>
      <Services
        title=">Green Renewable 
        Energy"
        heading="Green Renewable 
        Energy"
        text="Along with residential construction, solar power supply to the house is also provided. Lifelong freedom from WAPDA bills and 24/7 constant availability of electricity at home.

        Solar energy: on-grid system, off-grid system, battery backup storage and UPS, ie exactly what you need."
        Image={energy}
      />
    </div>
  );
};

export default index;
